var $85eee97d14eef7b5$exports = {};
$85eee97d14eef7b5$exports = {
  "removeButtonLabel": "Fjern",
  "removeDescription": "Trykk p\xE5 Slett for \xE5 fjerne taggen."
};
export { $85eee97d14eef7b5$exports as default };